import { render, staticRenderFns } from "./history-widgets.vue?vue&type=template&id=3d46a780&"
import script from "./history-widgets.vue?vue&type=script&lang=js&"
export * from "./history-widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports